import { useCallback } from 'react'
import Key from '@mui/icons-material/Key'
import { Button } from '@mui/material'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { EMAIL_REGEX, getRedirectUrl } from '@/utils/auth'
import { showErrorSnackbar } from '@/utils/snackbars'
import type { LoginViewOptions } from './Login'

export default function LoginWithSSO({ stytchOrg, email }: LoginViewOptions) {
  const stytch = useStytchB2BClient()

  const isEmailValid = EMAIL_REGEX.test(email)

  const handleStartSSO = useCallback(async () => {
    try {
      if (stytchOrg) {
        await stytch.sso.start({
          connection_id: stytchOrg.sso_default_connection_id as string,
          login_redirect_url: getRedirectUrl(),
        })
      } else {
        const ssoResponse = await stytch.sso.discoverConnections(email)
        if (!ssoResponse.connections.length) {
          showErrorSnackbar(
            'No SSO connections found for this email. Please try a different email or contact support.',
          )
          return
        }
        await stytch.sso.start({
          connection_id: ssoResponse.connections[0].connection_id,
          login_redirect_url: getRedirectUrl(),
        })
      }
    } catch (e) {
      console.error('Error during sign in:', e)
      showErrorSnackbar(
        'An error occurred during the request. Please try again.',
      )
    }
  }, [stytchOrg, stytch.sso, email])

  return (
    <Button
      startIcon={<Key />}
      onClick={handleStartSSO}
      disabled={!stytchOrg && !isEmailValid}
    >
      Continue with SSO
    </Button>
  )
}
